module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-5-ff4746ea94beb8030508842ea72eb23a.svg";